export default __webpack_public_path__ + "static/media/user_avatar_.4b1341f8.svg";